'use strict';

var _ = require('lodash');
var mapConfig = _.cloneDeep(require('./PreviewMapConfig.js'));

/** @OverlaySelectorStore */
var OverlaySelectorStore = function (ResourceHelper, Flux, OverlaySelectorActions, APP_DISPATCHER_ID, Utils) {

  var OverlayStore = Flux.Store.get('OverlayStore');
  var SiteStore = Flux.Store.get('SiteStore');
  // Store init
  var OverlaySelectorStore = Flux.Store.create({
    name: 'OverlaySelectorStore',
    events: {
      Changed : true
    }
  });

  // Null initial state
  OverlaySelectorStore.$state = {
    dialogVisibility : false,
    currentOverlayPreview : null,
    available: null,
    selectedOverlayId : null
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  OverlaySelectorStore.init = function init () {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(OverlaySelectorActions.OverlayPreviewSelected, this._handleOverlayPreviewSelected.bind(this));
    dispatcher.register(OverlaySelectorActions.ShowOverlaySelector, this._toggleDialogVisibility.bind(this));
    dispatcher.register(OverlaySelectorActions.HideOverlaySelector, this._toggleDialogVisibility.bind(this));

  }.bind(this);


  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Check when overlays are available for display
   */
  this._handleStoreChange = function _handleStoreChange () {
    var availableOverlays = OverlayStore.get('available');

    if (availableOverlays) {
      OverlaySelectorStore.$set('available', availableOverlays);
      OverlaySelectorStore.emit(OverlaySelectorStore.Events.Changed);
    }
  };

  /**
   * When a preview is selected in the list, upadtes the site list and adds the selected flag to the one on the ev.data
   * @param {object} [event] and event object containing the selected site on the list
   */
  this._handleOverlayPreviewSelected = function _handleSitePreviewSelected (ev) {
    OverlaySelectorStore.$set('currentOverlayPreviewMap', this.cookOverlayPreviewMap(ev.data.overlay));
    OverlaySelectorStore.$set('currentOverlayPreview', ev.data.overlay);
    OverlaySelectorStore.emit(OverlaySelectorStore.Events.Changed);
  };

  /**
   * Handles the visiblilty flag to show/hide the modal
   */
  this._toggleDialogVisibility = function _toggleDialogVisibility () {
    OverlaySelectorStore.$set('currentOverlayPreviewMap', this.cookOverlayPreviewMap({}));
    OverlaySelectorStore.$set('currentOverlayPreview', null);
    OverlaySelectorStore.$set('dialogVisibility', !OverlaySelectorStore.$state.dialogVisibility);
    OverlaySelectorStore.emit(OverlaySelectorStore.Events.Changed);
  };

  /**
   * Utility function to create a booster compatible site data
   */
  this.cookOverlayPreviewMap = function cookSitePreviewMap (overlay) {
    var location, mapUtil;
    var site = SiteStore.get('current');

    location = _.clone(site.location);
    mapConfig.mapCenter = _.pick(location, ['lat', 'lng', 'zoom']);
    mapConfig.mapCenter.zoom = Math.min(17, mapConfig.mapCenter.zoom);
    mapUtil = Utils.Map.create(mapConfig);
    location.bounds = L.latLngBounds(
      [location.bounds.bottom, location.bounds.left],
      [location.bounds.top, location.bounds.right]
    );

    var formatterOverlays = [{
      id: overlay.id,
      name: overlay.name,
      layers: [{
        id: overlay.id,
        layerId: overlay.layerId
      }]
    }];

    return {
      id: site.id,
      center: mapConfig.mapCenter,
      defaults: mapUtil.getMapDefaults(),
      events: mapConfig.events,
      overlays: formatterOverlays
    };

  };


  //Bindings

  OverlayStore.on(OverlayStore.Events.Changed, this._handleStoreChange.bind(this));

  return OverlaySelectorStore;
};

OverlaySelectorStore.$inject = ['ResourceHelper', 'sbFlux', 'OverlaySelectorActions', 'APP_DISPATCHER_ID', 'Utils'];
module.exports = OverlaySelectorStore;


// WEBPACK FOOTER //
// ./src/app/dash/overlaySelector/OverlaySelectorStore.js